import { Message } from 'element-ui';

function htmlReplace(html) {
  return html.replace(/[<>&\n]/g, function (x) {
    return {
      '<': '&lt;',
      '>': '&gt;',
      '&': '&amp;',
      '\n': '<br />',
    }[x];
  });
}

window._viewErrorStack = function (a) {
  window.$(a).parent().find('div').toggle("fast");
}

// 堆栈消息
function stackMsg(error, url, stack = '') {

  let pre_html = stack ? `<pre style="white-space: pre-wrap;padding:10px;margin:10px 0 0 0;font-size: 12px;color:#fff;background:#1b265a;max-height:500px;">${stack}</pre>` : '';

  let arr_html = [
    error + ' ',
    "请 <span style='cursor:pointer;color:#3f51b5;text-decoration:underline;' onclick='_viewErrorStack(this)'>查看详情</span> 并截图给系统管理员",
    "&nbsp;",
    `<div style="display: none;"><p style="color:#000;margin-top:10px;">URL：${url}</p>${pre_html}</div>`,
  ];

  Message({ type: 'error', dangerouslyUseHTMLString: true, duration: 0, showClose: true, message: arr_html.join('') });
}

// 工具方法
function statusTextZH(code) {
  let text = `[${code}] `;
  switch (code) {
    case 401: text += "未授权";
      break;
    case 404: text += "无法找到资源";
      break;
    case 405: text += "不允许的方法";
      break;
    case 500: text += "服务器返回错误";
      break;
    default: text += "其它错误"
  }
  return text;
}

// 状态码消息
function statusMsg(status, url, more = '') {
  let error = statusTextZH(status);
  let stack = htmlReplace(more);
  stackMsg(error, url, stack);
}


export {
  stackMsg,
  statusMsg,
  htmlReplace
}